import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ElectricianDetailClient.tsx");
